module.exports = __webpack_public_path__ + "static/media/recreate-mode.0c4781dd.svg";